import type { ReactNode } from 'react'

type Props = { title: string; lead?: ReactNode; children?: ReactNode }

export default function StepHeader({ title, lead, children }: Props) {
	return (
		<header className="mx-auto max-w-2xl text-center leading-6 font-light">
			<h2 className="text-3xl font-semibold">{title}</h2>
			{lead && <p className="text-default-500 my-2">{lead}</p>}
			{children}
		</header>
	)
}
